













import { Vue, Component } from 'vue-property-decorator';
import fireFlies from './2019FMXY/common/fireflies';

@Component
export default class Loading extends Vue {
  mounted() {
    fireFlies.fireFlies();
  }
}
